import { AlertCircleIcon as AlertCircle, CheckCircleIcon as CheckCircle, Loader2Icon as Loader2, XIcon as X } from '../../icons';
import ProgressBar from './ProgressBar';
import StepBadges from './StepBadges';
import { ExportFileStats, ExportState } from '../types';

export interface ExportProgressViewProps {
  exportState: ExportState;
  progress: number;
  currentObjectName: string;
  currentMessage: string;
  currentEtapa: string;
  fileStats: ExportFileStats;
  progressInfo: { total: number; processed: number; currentIndex?: number; titles?: string[] };
  onClose: () => void;
}

export default function ExportProgressView({ exportState, progress, currentObjectName, currentMessage, currentEtapa, fileStats, progressInfo, onClose }: ExportProgressViewProps) {
  return (
    <div className="fixed inset-0 bg-navy-900/80 backdrop-blur-sm flex items-center justify-center z-50">
      <div id="export-progress-modal" className="bg-navy-800 rounded-lg w-full max-w-lg animate-fadeIn shadow-xl">
        <div className="flex justify-between items-center border-b border-navy-700 p-4">
          <h2 className="text-xl font-semibold text-white">Exportando Layout</h2>
          {exportState === 'success' && (
            <button onClick={onClose} className="text-gray-400 hover:text-white" aria-label="Fechar">
              <X size={20} />
            </button>
          )}
        </div>

        <div className="p-6">
          <div className="space-y-6">
            {/* Status Section */}
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                {exportState === 'error' ? (
                  <div className="p-2 bg-red-900/30 rounded-full transition-all duration-300">
                    <AlertCircle size={20} className="text-red-400" />
                  </div>
                ) : exportState === 'success' || exportState === 'finished' ? (
                  <div className="p-2 bg-emerald-900/30 rounded-full transition-all duration-300">
                    <CheckCircle size={20} className="text-emerald-400" />
                  </div>
                ) : (
                  <div className="p-2 bg-navy-700 rounded-full transition-all duration-300">
                    <Loader2 size={20} className="text-blue-400 animate-spin" />
                  </div>
                )}
              </div>
              <div className="flex-1">
                <h3 className={`font-medium text-lg transition-colors duration-300 ${exportState === 'error' ? 'text-red-400' : 'text-white'}`}>
                  {currentEtapa || 'Preparando exportação'}
                </h3>
                {/* Só exibe currentMessage quando não há currentObjectName para evitar duplicidade */}
                {!currentObjectName && (
                  <p className="text-gray-400 text-sm mt-1 transition-opacity duration-200">
                    {currentMessage}
                  </p>
                )}
              </div>
            </div>

            {/* Progress Section */}
            <div className="space-y-3">
              <div className="flex justify-between text-sm text-white font-medium">
                <span>Progresso</span>
                <span>{progressInfo.processed} de {progressInfo.total}</span>
              </div>
              <ProgressBar value={progress} />
              {currentObjectName && (
                <p className="text-gray-400 text-sm">
                  Processando: {currentObjectName}
                </p>
              )}
              <StepBadges total={progressInfo.total} processed={progressInfo.processed} currentIndex={progressInfo.currentIndex} titles={progressInfo.titles} />
            </div>

            {/* Action Section */}
            <div className="pt-2">
              <button 
                onClick={onClose}
                disabled={exportState !== 'success'}
                className={`w-full py-3 rounded-md font-medium transition-colors ${exportState === 'success' ? 'bg-navy-700 hover:bg-navy-600 text-white' : 'bg-navy-700/60 text-gray-400 cursor-not-allowed'}`}
              >
                {exportState === 'success' ? 'Fechar' : 'Cancelar'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


